import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FiDownload } from "react-icons/fi";
import { AuthApis } from "../../../api/auth/auth";
import { toast } from "react-toastify";
/* import { generateExcel } from "./generateExcel"; */

export default function ExportPage() {



const handleExport = async () => {
  try {
    const response = await AuthApis.GetSummary();
    const data = response.data?.data || [];

    if (!Array.isArray(data) || data.length === 0) {
      toast.warning("No data found to export.");
      return;
    }

    // Current date & time
    const now = new Date();
    const extractDate = `${now.getMonth() + 1}/${String(now.getDate()).padStart(2, "0")}/${now.getFullYear()}`;
    console.log(extractDate); 
    const extractTime = now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // ✅ Define header map (API field → Excel header)
    const headerMap = {
      "Extract Date": "Extract Date",
      "Extract Time": "Extract Time",
      input_date: "Input Date",
      input_time: "Input Time",
      question_completion_status: "Question Completion Status",
      user_email: "User Email",
      company_name: "Company Name",
      
    };

    // ✅ Transform data using header map
    const transformedData = data.map((row) => {
      const newRow = {
         "Extract Date": extractDate,
        "Extract Time": extractTime,
      };
      Object.keys(row).forEach((key) => {
        if (headerMap[key]) {
          newRow[headerMap[key]] = row[key]; // rename column
        } else {
          newRow[key] = row[key]; // fallback if not in headerMap
        }
      });
      return newRow;
    });

    // ✅ Define column order
    const columnOrder = Object.values(headerMap);

    // Convert JSON → Excel with custom headers
 const worksheet = XLSX.utils.json_to_sheet(transformedData, {
  header: columnOrder,
});

/* worksheet['!rows'] = transformedData.map(() => ({ hpt: 40 }));  */

worksheet['!cols'] = columnOrder.map((col) => {
  return { wch: 20 }; 
  // wch = width in "characters", adjust number as needed
  // For example, 20 is wide enough for most text
});

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Summary");

    // Save Excel
   const excelBuffer = XLSX.write(workbook, {
  bookType: "xlsx",
  type: "array",
});
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "assessment_summary.xlsx");

    toast.success("Export completed successfully!");
  } catch (error) {
    console.error("Export failed:", error);
    toast.error("Failed to export summary.");
  }
};



  return (
    <div className="container-fluid d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <div className="text-center">
        {/*    <h3 className="mb-4 fw-bold text-dark">Export Data</h3> */}
        <button
          className="btn btn-primary btn-lg px-5 py-3 d-flex align-items-center justify-content-center mx-auto shadow rounded-pill"
          onClick={handleExport}
        >
          <FiDownload size={24} className="me-2" />
          Download
        </button>
        <p className="text-muted mt-3 small">
          Please Click on download button to extract all Entries.
        </p>
      </div>
    </div>
  );
}
